import { render } from "./ImpressumDescription.vue?vue&type=template&id=22cceb78"
import script from "./ImpressumDescription.vue?vue&type=script&lang=js"
export * from "./ImpressumDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__